import katex from "katex";
import { HttpService } from "../Common/http-service";
import { IRenderWikiOptions, IWikiLinkDefinition } from "../interfaces";

export class TrifortCMSWikiService {
    private _wikiContainerSelector: string;

    public constructor(wikiContainerSelector: string) {
        this._wikiContainerSelector = wikiContainerSelector;
    }

    public async RenderWiki(options: IRenderWikiOptions) {
        var self = this;
        
        var wikiHtml = self.GetWikiHtml(options);
        $(self._wikiContainerSelector).html(wikiHtml);

        await self.HandleLandingPage(options);
        await self.HookupEventListeners();
    }

    private GetWikiHtml(options: IRenderWikiOptions) {
        var self = this;

        return `
<div id="trifortCmsWikiContainer">
    <div id="trifortCmsWikiSidebar">
        <div id="trifortCmsWikiSidebarHeading">${options.wikiTitle}</div>
        ${self.GetWikiLinksHtml(options.wikiLinks)}
    </div>
    <div id="trifortCmsWikiContents"></div>
</div>
        `;
    }

    private GetWikiLinksHtml(links: IWikiLinkDefinition[]): string {
        var self = this;

        var linkHtml: string = '';

        links.forEach((link: IWikiLinkDefinition) => {
            linkHtml += self.GetWikiLinkHtml(link);
        });

        return `<ul id="trifortCmsWikiLinks">${linkHtml}</ul>`
    }

    private GetWikiLinkHtml(link: IWikiLinkDefinition): string {
        var self = this;
        
        var pageFileValue = link.pageFileName;
        var htmlHashValue = self.GetLinkHashValue(link);
        var titleHtml = "";

        if (pageFileValue) {
            var pageFileHtml: string = pageFileValue ? `data-file-name="${pageFileValue}"` : "";
            var htmlHashHtml = htmlHashValue ? `href="#${htmlHashValue}"` : "";

            titleHtml = `<a ${htmlHashHtml} ${pageFileHtml}>${link.title}</a>`
        }
        else {
            titleHtml = link.title;
        }

        if (link.children) {
            var childListHtml = "";

            link.children.forEach((child: IWikiLinkDefinition) => {
                childListHtml += self.GetWikiLinkHtml(child);
            })

            return `<li>${titleHtml} <ul>${childListHtml}</ul></li>`
        }
        else {
            return `<li>${titleHtml}</li>`
        }
    }

    private HookupEventListeners() {
        var self = this;

        // Handle changing the page on link click.
        $(`${self._wikiContainerSelector} #trifortCmsWikiLinks a`).off("click").on("click", async function (event) {
            var fileName = $(this).data("file-name");
            await self.FetchAndRenderWikiPage(fileName);
        });

        // Handle expanding and hiding sub lists
        $(`${self._wikiContainerSelector} #trifortCmsWikiLinks li:has(ul)`).off("click").on("click", async function (event) {
            $(event.target).toggleClass("showSubList");
        });
    }

    private async FetchAndRenderWikiPage(pageName: string) {
        var self = this;

        if (!pageName.endsWith(".md"))
            pageName += ".md";

        const httpResponse = await HttpService.getDataAsync(`/WikiPage/${pageName}`, null);

        if (!HttpService.hasErrors(httpResponse)) {
            $(`${self._wikiContainerSelector} #trifortCmsWikiContents`).hide();
            $(`${self._wikiContainerSelector} #trifortCmsWikiContents`).html(httpResponse.Data as string);

            self.RenderPageMaths();
            $(`${self._wikiContainerSelector} #trifortCmsWikiContents`).show();
        }
    }

    private RenderPageMaths() {
        var self = this;

        // The Latex code is wrapped in .math spans, so we can go to each one and interpret them with katex.
        $(`${self._wikiContainerSelector} .math`).each(function () {
            var expression = $(this).text();

            if (expression.startsWith("\\(") || expression.startsWith("\\["))
                expression = expression.slice(2);
            if (expression.endsWith("\\)") || expression.startsWith("\\]"))
                expression = expression.slice(0, -2);

            katex.render(expression, this);
        });
    }

    private async HandleLandingPage(options: IRenderWikiOptions) {
        var self = this;

        // If there's a hash value, open that page. 
        var hashValue = window.location.hash
        
        if (hashValue.length > 0) {
            hashValue = hashValue.substring(1);

            var matchingPages = options.wikiLinks.filter((link) => self.GetLinkHashValue(link) == hashValue);

            if (matchingPages.length > 0) {
                await self.FetchAndRenderWikiPage(matchingPages[0].pageFileName);
                return;
            }
        }

        // Else, go to the default landing page if one is defined.
        if (options.defaultLandingPageFileName) {
            await self.FetchAndRenderWikiPage(options.defaultLandingPageFileName);
        }
    }

    private GetLinkHashValue(linkDefinition: IWikiLinkDefinition) {
        return linkDefinition.htmlHash ?? linkDefinition.pageFileName
    }
}
